import { PlusIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const AddOptionButton = ({content, onClick}) => {
    return (
        <>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                    <div
                        onClick={() => onClick(true)}
                        className="absolute right-2 top-2 text-gray-500 hover:text-blue-500 cursor-pointer"
                    >
                        <PlusIcon className="w-5 h-5" />
                    </div>
                    </TooltipTrigger>
                    <TooltipContent side="bottom" align="end" className="flex bg-primary text-white p-2 rounded transform -translate-x-2">
                    {content}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </>
    );
};

export default AddOptionButton;
